<template>
    <p> The page you are looking for is not here. Please press 'Back' on your browser or navigate to the home page: https://www.proximaldtx.com. </p>
</template>